import { render, staticRenderFns } from "./externalInvestList.vue?vue&type=template&id=494e3a42&scoped=true"
import script from "./externalInvestList.vue?vue&type=script&lang=js"
export * from "./externalInvestList.vue?vue&type=script&lang=js"
import style0 from "./externalInvestList.vue?vue&type=style&index=0&id=494e3a42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494e3a42",
  null
  
)

export default component.exports